module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/pc.fe172f17.png";